<template>
    <div>
        <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
            <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-radio-group class="no_space_vertical" :disabled="preview" v-model="measures.has_desc" label="Presenza prove di scarico">
                        <v-radio label="Presenti" value="on"></v-radio>
                        <v-radio label="Non presenti" value="off"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="5" v-if="measures">
                        <NumericField
                        dense outlined
                        :readonly="preview"
                        class="text-left"
                        label="Peso specifico"
                        v-model="measures.specific_weight"
                        placeholder="1.0"
                        @input="calculateAll()"
                        />
                    </v-col>
                    
                </v-row>
                <v-row no-gutters v-if="!preview">
                    <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2" v-if="!preview">
                        <v-btn @click="handleAllPlaceHolders()" color="primary">Riempimento automatico</v-btn>
                    </div>
                </v-row>
                <v-row no-gutters>
                <v-row no-gutters>
                    <span class="subtitle-2"><b>Misure Asc.</b></span>
                </v-row>
                <v-simple-table class="measure_table">
                    <template v-slot:default>
                        <thead class="expansion">
                            <tr>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.count }}</th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.reading }} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.readingCalc }} <br/><i class="caption">({{computedUom}})</i> </th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.primaryReading }} <br/><i class="caption">({{computedUom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.difference }} <br/><i class="caption">({{computedUom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.toleranceError}}<br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.tolerance }}<br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.result }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in measures.items" :key="index">
                                <td class="table-blocks d-flex align-center">
                                    <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                                    <div v-else class="d-flex pr-4"></div>
                                    <div class="d-flex justify-center flex-shrink-0 flex-grow-1 pr-1">{{item.position}}</div>
                                </td>
                                <td class="table-blocks">
                                    <NumericField
                                        dense outlined
                                        solo hide-details
                                        :readonly="preview"
                                        class="text-left"
                                        v-model="item.reading"
                                        @input="calculateReading(item)"
                                        :class="readingWarning(item.reading)"
                                        :precision="precision"
                                        :enableicons="!preview"
                                        :addfunc="readingAddFunc"
                                        :subfunc="readingSubFunc"
                                        :row="item"
                                        :fieldname="'reading'"
                                        :range="calcMinRange(item.reading)"
                                    />
                                    <!-- @blur="handleBlur(item, 'reading')" -->
                                </td>
                                <td class="table-blocks text-center">
                                    <NumericField
                                        dense outlined
                                        hide-details
                                        disabled
                                        v-model="item.readingCalc"
                                    />
                                </td>
                                <td class="table-blocks">
                                    <NumericField
                                        dense outlined
                                        solo hide-details
                                        :readonly="preview"
                                        class="text-left"
                                        :placeholder="readingPlaceholder(item.readingCalc)"
                                        v-model="item.primaryReading"
                                        :precision="comparison_precision"
                                    />
                                    <!--@blur="handleBlur(item, 'reading')"-->
                                </td>
                                <td class="table-text-blocks text-right"><b >{{item.difference | formatNumber}}</b></td>
                                <td class="table-text-blocks text-right"><b>{{item.toleranceError | formatNumber}}</b></td>
                                <td class="table-text-blocks text-right"><b >{{item.tolerance | formatNumber}}</b></td>
                                <td class="table-text-blocks text-right">
                                    <StatusIcon 
                                        :status="item.result"
                                        :tooltip_text="row_tooltip[item.result]" />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                        <div v-if="precision_overflow_up" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                    </div>
                </v-row>
                <div class="d-flex flex-column" v-if="checkDescent">
                <v-row no-gutters>
                    <span class="subtitle-2"><b>Misure Disc.</b></span>
                </v-row>
                <v-row no-gutters>
                <v-simple-table class="measure_table">
                    <template v-slot:default>
                        <thead class="expansion">
                            <tr>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.count }}</th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.reading }} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.readingCalc }} <br/><i class="caption">({{computedUom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.primaryReading }} <br/><i class="caption">({{computedUom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.difference }} <br/><i class="caption">({{computedUom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.toleranceError}}<br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.tolerance }}<br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.result }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in measures.items_down" :key="index">
                                <td class="table-blocks d-flex align-center">
                                    <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                                    <div v-else class="d-flex pr-4"></div>
                                    <div class="d-flex justify-center flex-shrink-0 flex-grow-1 pr-1">{{item.position}}</div>
                                </td>
                                <td class="table-blocks">
                                    <NumericField
                                        dense outlined
                                        solo hide-details
                                        :readonly="preview"
                                        class="text-left"
                                        v-model="item.reading"
                                        @input="calculateReading(item)"
                                        :class="readingWarning(item.reading)"
                                        :precision="precision"
                                    />
                                    <!-- @blur="handleBlur(item, 'reading')" -->
                                </td>
                                <td class="table-blocks text-center">
                                    <NumericField
                                        dense outlined
                                        hide-details
                                        disabled
                                        v-model="item.readingCalc"
                                    />
                                </td>
                                <td class="table-blocks">
                                    <NumericField
                                        dense outlined
                                        solo hide-details
                                        :readonly="preview"
                                        class="text-left"
                                        :placeholder="readingPlaceholder(item.readingCalc)"
                                        v-model="item.primaryReading"
                                        :precision="comparison_precision"
                                    />
                                    <!--@blur="handleBlur(item, 'reading')"-->
                                </td>
                                <td class="table-text-blocks text-right"><b >{{item.difference | formatNumber}}</b></td>
                                <td class="table-text-blocks text-right"><b>{{item.toleranceError | formatNumber}}</b></td>
                                <td class="table-text-blocks text-right"><b >{{item.tolerance | formatNumber}}</b></td>
                                <td class="table-text-blocks text-right">
                                    <StatusIcon 
                                        :status="item.result"
                                        :tooltip_text="row_tooltip[item.result]" />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                        <div v-if="precision_overflow_down" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                </div>
                <div class="d-flex flex-grow-0 flex-shrink-1 my-2">
                    <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow()"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                </div>
                </v-row>
                </div>
            </v-container>                
            </div>
        </LayoutBlock>
        
    </div>
</template>
<script>
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from '../../../components/utils/StatusIcon'
import {BaseIsoSimple} from "../../../utils/baseIsoSimple"
import {liter_doser_item} from "../../../utils/itemBlockSchema"
import Big from "big.js"

export default {
    mixins: [BaseIsoSimple],
    components: {LayoutBlock, StatusIcon},
    methods:{
        async buildMeasures(){
            this.measures = {
                items: [],
                items_down: [],
                has_desc: "off",
                tolerance: null,
                specific_weight: 0,
                result: 'uncomplete'
            }
            this.buildTolerances()
            let valuesFromCategory = await this.buildWithCategory()
            if(valuesFromCategory){
                for (let i = 0; i< this.data.block.conf.min_readings; i++){
                    this.addRow(valuesFromCategory[i])
                    this.calculateReading(this.measures.items[i])
                }
            } else {
                for (let i = 0; i< this.data.block.conf.min_readings; i++){
                    this.addRow()
                }
            }
        },
        addRow(nom_value = null){
            let item = liter_doser_item({
                reading: nom_value,
                position: this.measures.items.length + 1,
                tolerance: this.measures.tolerance
            })
            let item2 = liter_doser_item({
                reading: nom_value,
                position: this.measures.items.length + 1,
                tolerance: this.measures.tolerance
            })
            this.measures.items.push(item)
            this.measures.items_down.unshift(item2)
        },
        calcError(row){
            if(row.reading != null && row.reading != '' && row.primaryReading != null && row.primaryReading != ''){
                row.difference = this.round(this.differenceInt(row.readingCalc, row.primaryReading), this.comparison_precision)
                row.toleranceError = this.handleToleranceError(row, "liter")
                this.calculateResultTolerance(row, row.tolerance)
            } else {
                row.result = "uncomplete"
            }
        },
        calcDiff(){
            for(let item of this.measures.items){
                this.calcError(item)
            }
            if(this.checkDescent){
                for(let item of this.measures.items_down){
                    this.calcError(item)
                }
            }
        },
        calculateReading(row){
            if(row.reading){
                row.readingCalc = this.round(Big(row.reading).times(this.measures.specific_weight))
                this.changeTolerance(row)
            } 
        },
        calculateAll(){
            if(this.measures.specific_weight){
                for(let row of this.measures.items){
                    this.calculateReading(row)
                }
                if(this.checkDescent){
                    for(let row2 of this.measures.items_down){
                        this.calculateReading(row2)
                    }
                }
            }
        },
        handleAllPlaceHolders(){
            this.convertPlaceholders(this.measures.items, this.instrument_data.family)
            if(this.checkDescent){
                this.convertPlaceholders(this.measures.items_down, this.instrument_data.family)
            }
        },
        calcBlockResult() {
            // console.log('CALC BLOCK RESULT')
            let result_up = 'done'
            result_up = this.measures.items.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            let result_down = 'done'
            if(this.checkDescent){
                result_down = this.measures.items_down.reduce(function(result, item){
                    let res = 'done'
                    switch (item.result) {
                        case 'uncomplete':
                            res = 'uncomplete'
                            break
                        case 'failed':
                            if (result == 'uncomplete') {
                                res = 'uncomplete'
                            } else {
                                res = 'failed'
                            }
                            break
                        case 'done':
                            res = result
                            break
                    }
                    return res
                }, 'done')
            }
            // console.log('CALC BLOCK RESULT', result_up, result_down)
            if (result_up == result_down && result_up == "done") {
                if(this.precision_overflow_up || this.precision_overflow_down){
                    this.measures.result = 'failed' 
                } else {
                    this.measures.result = result_up
                }
            }  else if (result_up == 'uncomplete' || result_down == 'uncomplete') {
                this.measures.result = 'uncomplete'
            } else if (result_up == 'failed' || result_down == 'failed') {
                this.measures.result = 'failed'
            }
            // console.log('CALC BLOCK RESULT', result_up, result_down, this.measures.result)
        }
    },
    computed: {
        computedUom(){
            if(this.data){
                let k = this.data.instrument_data.uom
                if(k == "l"){
                    return "kg"
                } else if(k == "ml"){
                    return "g"
                } else {
                    return ""
                }
            }
            return ""
        },
        checkDescent(){
            if(this.measures && this.measures.has_desc){
                if(this.measures.has_desc == "on") {
                    return true
                }
            }
            return false
        },
        precision_overflow(){
            if(this.measures){
                return this.precision_overflow_up && this.precision_overflow_down
            } else {
                return false
            }
        },
        precision_overflow_up() {
            if(this.measures){
                for (let elm of this.measures.items) {
                    let res = this.checkReading(elm.reading)
                    switch (res) {
                        case 'uncomplete':
                        case 'done':
                            break
                        case 'failed':
                            return true
                    }
                }
            }
            return false
        },
        precision_overflow_down() {
            if(this.measures){
                for (let elm of this.measures.items_down) {
                    let res = this.checkReading(elm.reading)
                    switch (res) {
                        case 'uncomplete':
                        case 'done':
                            break
                        case 'failed':
                            return true
                    }
                }
            }
            return false
        },
        // reading_overflow(){
        //     if(this.measures){
        //         return this.reading_overflow_up && this.reading_overflow_down
        //     } else {
        //         return false
        //     }
        // },
        // reading_overflow_up() {
        //     for (let elm of this.measures.items) {
        //         let res = this.checkReading(elm.primaryReading)
        //         switch (res) {
        //             case 'uncomplete':
        //             case 'done':
        //                 break
        //             case 'failed':
        //                 return true
        //         }
        //     }
        //     return false
        // },
        // reading_overflow_down() {
        //     for (let elm of this.measures.items) {
        //         let res = this.checkReading(elm.primaryReading)
        //         switch (res) {
        //             case 'uncomplete':
        //             case 'done':
        //                 break
        //             case 'failed':
        //                 return true
        //         }
        //     }
        //     return false
        // }
    }

}
</script>